import { configureStore } from '@reduxjs/toolkit';
import signinSlice from './sign-in/signinSlice.js'; 
import usersSlice from './slices/users/usersSlice.js';
import delegatesSlice from './slices/delegates/delegatesSlice.js';
import regionsSlice from './slices/regions/regionsSlice.js';
import governmentsSlice from './slices/governments/governmentsSlice.js';
import personsSlice from './slices/persons/personsSlice.js';
import specialtysSlice from './slices/specialtys/specialtysSlice.js';
import productsSlice from './slices/products/productsSlice.js';
import rapportsSlice from './slices/rapports/rapportsSlice.js';
import samplesSlice from './slices/samples/samplesSlice.js';
import uploadDoctorSlice from './slices/importDoctors/importPersonsSlice.js';
import uploadOthersSlice from './slices/importOthers/importPersonsSlice.js';
import planningReducer from './slices/planning/planningSlice.js';
import givenSamplesReducer from './slices/givenSamples/givenSamplesSlice';
import rolesReducer from './slices/roles/rolesSlice'; 
import auditReducer from './slices/audit/auditSlice';
import supervisorsReducer from './slices/supervisors/supervisorsSlice';
import clinicReportsReducer from './slices/clinicReports/clinicReportsSlice';

// --- NOUVEL IMPORT ---
import stocksReducer from './slices/stocks/stocksSlice'; 

export const store = configureStore({
  reducer: {
    signin: signinSlice,
    users: usersSlice,
    delegates: delegatesSlice,
    regions: regionsSlice,
    governments: governmentsSlice,
    persons: personsSlice,
    specialtys: specialtysSlice,
    products: productsSlice,
    rapports: rapportsSlice,
    samples: samplesSlice,
    uploadDoctor: uploadDoctorSlice,
    uploadOthers: uploadOthersSlice,
    planning: planningReducer,
    givenSamples: givenSamplesReducer,
    roles: rolesReducer,
    audit: auditReducer,
    supervisors: supervisorsReducer,
    
    // --- AJOUT DU MODULE STOCKS ---
    stocks: stocksReducer,
    clinicReports: clinicReportsReducer
  },
});